import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITaskRequest } from '../../../modules/tasks/model/types';


@Component({
  standalone: false,
  selector: 'app-new-task',
  templateUrl: './new-task.component.html',
  styleUrls: ['./new-task.component.css']
})
export class NewTaskComponent implements OnInit {
 @Input() addNewTemplateType: string;
 @Input() taskTemplateName: string;
 @Input() taskMetadata: any;
 @Input() task: ITaskRequest
 

 @Output() addNewTaskEventEmitter: EventEmitter<any> = new EventEmitter();

  onAddNewTask(e: any)
  {
    this.addNewTaskEventEmitter.emit(e);
  }
 
  constructor() { }

  ngOnInit() {
    
  }

}
